import { createContext, useContext, useMemo, useState } from 'react'

export interface RedirectContextType {
    redirectUri: string
    setRedirectUri: (uri: string) => void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RedirectProvider = (props: any): JSX.Element => {
    const [redirectUri, setRedirectUri] = useState('')

    const valueContext = useMemo(() => ({ redirectUri, setRedirectUri }), [redirectUri])

    return <RedirectContext.Provider value={valueContext} {...props} />
}

const redirectContextEmpty: RedirectContextType = {
    redirectUri: '',
    setRedirectUri: (uri: string): void => {
        throw new Error('setRedirectUri not implemented')
    },
}
const RedirectContext = createContext(redirectContextEmpty)

const useRedirect = (): RedirectContextType => useContext(RedirectContext)

export { RedirectProvider, useRedirect }
